<template>
  <picture class="md:w-6/12 sm:w-full">
    <img
      class="object-cover w-full h-full brightness-[0.8]"
      src="@/assets/meridia-field.webp"
      alt="Meridia field"
      width="500"
      height="600"
      loading="eager"
    />
  </picture>
</template>
<script setup lang="ts"></script>
